import {
	getTemplateKeyField,
	getDateField,
	getImageField,
	TITLE_FIELD,
	AUTHOR_FIELD,
	PUBLISH_DATE_FIELD,
	DESCRIPTION_FIELD,
	FEATURED_FIELD,
	IMAGE_FIELD,
	IMAGE_ALT_FIELD,
	BODY_FIELD,
	TAGS_FIELD,
	IMAGE_Y_POSITION_FIELD,
	POST_ID_FIELD,
	POST_TO_FB_FIELD,
	POST_TO_TWITTER_FIELD,
	SOCIAL_TEXT_FIELD,
	LOCATION_FIELD,
	SHOW_DATE_FIELD,
	LIVE_DATE_FIELD,
	ALL_SALE_INDEX_FIELD,
	SHOW_NEW_FIELD,
	SHOW_DISCLAIMER_FIELD,
} from "./fields";

const getPostCollection = (name, label, template, overrides = {}) => ({
	name,
	label,
	"folder": `content/${name}`,
	"filter": {
		"field": "templateKey",
		"value": template,
	},
	"create": true,
	"slug": "{{year}}-{{month}}-{{day}}-{{slug}}",
	"summary": "[{{year}}/{{month}}/{{day}}] {{title}}",
	"preview_path": `${name}/{{year}}-{{month}}-{{day}}-{{slug}}`,
	"preview_path_date_field": "date",
	"delete": false,
	...overrides,
});

const blogCollection = {
	...getPostCollection("blog", "Blog", "blog-post"),
	"fields": [
		getTemplateKeyField("blog-post"),
		TITLE_FIELD,
		AUTHOR_FIELD,
		PUBLISH_DATE_FIELD,
		DESCRIPTION_FIELD,
		FEATURED_FIELD,
		IMAGE_FIELD,
		IMAGE_ALT_FIELD,
		BODY_FIELD,
		{ ...TAGS_FIELD, "required": true },
		IMAGE_Y_POSITION_FIELD,
		POST_ID_FIELD,
		POST_TO_FB_FIELD,
		POST_TO_TWITTER_FIELD,
		SOCIAL_TEXT_FIELD,
	]
};

const productsCollection = {
	...getPostCollection("products", "Products", "product-page"),
	"fields": [
		getTemplateKeyField("product-page"),
		TITLE_FIELD,
		PUBLISH_DATE_FIELD,
		DESCRIPTION_FIELD,
		FEATURED_FIELD,
		IMAGE_FIELD,
		IMAGE_ALT_FIELD,
		{
			"label": "Amazon Id",
			"name": "amazonId",
			"widget": "string",
			"required": false
		},
		// {
		// TODO - ALIEXPRESS ID/URL
		// },
		BODY_FIELD,
		TAGS_FIELD,
		IMAGE_Y_POSITION_FIELD,
		POST_ID_FIELD,
		POST_TO_FB_FIELD,
		POST_TO_TWITTER_FIELD,
		SOCIAL_TEXT_FIELD,
		ALL_SALE_INDEX_FIELD,
		SHOW_NEW_FIELD,
		SHOW_DISCLAIMER_FIELD
	]
};

const eventsCollection = {
	...getPostCollection("events", "Events", "event-page"),
	"fields": [
		getTemplateKeyField("event-page"),
		TITLE_FIELD,
		DESCRIPTION_FIELD,
		getDateField("Event Date"),
		{
			"label": "Link to Event (FB)",
			"name": "link",
			"widget": "string",
			"required": false,
			"default": ""
		},
		SHOW_DATE_FIELD,
		FEATURED_FIELD,
		BODY_FIELD,
		IMAGE_FIELD,
		IMAGE_ALT_FIELD,
		LOCATION_FIELD,
		TAGS_FIELD,
		IMAGE_Y_POSITION_FIELD,
		POST_ID_FIELD,
		POST_TO_FB_FIELD,
		POST_TO_TWITTER_FIELD,
		SOCIAL_TEXT_FIELD,
	]
};

const glossaryCollection = {
	...getPostCollection("glossary", "Glossary Item", "glossary-item-page", {
		"slug": "{{slug}}",
		"summary": "{{title}}",
		"preview_path_date_field": undefined,
	}),
	"fields": [
		getTemplateKeyField("glossary-item-page"),
		TITLE_FIELD,
		DESCRIPTION_FIELD,
		BODY_FIELD,
		getImageField({ default: "https://res.cloudinary.com/montessoribaby/image/upload/v1566337022/pages/glossary.jpg" }),
		IMAGE_ALT_FIELD,
		IMAGE_Y_POSITION_FIELD,
		POST_ID_FIELD,
	]
};

const testimonialCollection = {
	...getPostCollection("testimonials", "Testimonials", "index-page", {
		"slug": "{{slug}}",
		"summary": "{{name}}",
		"identifier_field": "name",
		"preview_path_date_field": undefined,
	}),
	"fields": [
		getTemplateKeyField("index-page"),
		{
			"label": "Name",
			"name": "name",
			"widget": "string"
		},
		{
			"label": "Role",
			"name": "role",
			"widget": "string"
		},
		BODY_FIELD,
		POST_ID_FIELD,
		{
			"label": "Type",
			"name": "type",
			"widget": "hidden",
			"default": "testimonial"
		},
		getImageField({
			"required": false,
			"media_library": {
				"config": {
					"default_transformations": [
						[
							{
								"fetch_format": "png",
								"format": "png",
								"quality": "auto",
								"crop": "thumb",
								"radius": "max",
								"effect": "sepia",
								"width": 140,
								"height": 100,
								"dpr": 2
							}
						]
					]
				}
			}
		}),
	]
};

const libraryCollection = {
	...getPostCollection("library", "Library", "library-page"),
	"fields": [
		getTemplateKeyField("library-page"),
		TITLE_FIELD,
		PUBLISH_DATE_FIELD,
		DESCRIPTION_FIELD,
		FEATURED_FIELD,
		IMAGE_FIELD,
		IMAGE_ALT_FIELD,
		LIVE_DATE_FIELD,
		BODY_FIELD,
		TAGS_FIELD,
		IMAGE_Y_POSITION_FIELD,
		POST_ID_FIELD,
		ALL_SALE_INDEX_FIELD,
	]
};


export default [
	blogCollection,
	productsCollection,
	eventsCollection,
	glossaryCollection,
	testimonialCollection,
	libraryCollection,
];
